import { HttpClient, HttpErrorResponse, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseService, RubroMotivoRechazo } from '../types/type';
import { catchError, retry, throwError, zip } from 'rxjs';
import { Utilerias } from '../helpers/Utilerias';
import { PlaneacionService } from './planeacion.service';
import { RevisionesFiltroDTO } from '../types/Entitys';

enum methods {
  GetCatalogoEtapaRevisiones = 'GetCatalogoEtapaRevisiones',
  GetCatalogoRegiones = 'GetCatalogoRegiones',
  GetEstaciones = 'GetEstaciones',
  GetRevisionesFiltro = 'GetRevisionesFiltro',
  GetCatalogoEstatusRubros = 'GetCatalogoEstatusRubros',
  GetChecklistSeguimiento = 'GetChecklistSeguimiento',
  GetRevision = 'GetRevision',
  GetRangoCalificacionChecklists = 'GetRangoCalificacionChecklists',
  SetTranRubroMotivoRechazo = 'SetTranRubroMotivoRechazo',
}

@Injectable({
  providedIn: 'root'
})
export class SeguimientoService {
  headers: HttpHeaders;
  URL: string

  constructor(private http: HttpClient, private revisionServicio: PlaneacionService) {
    this.URL = environment.urlService
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  loadInit() {
    return zip(
      this.revisionServicio.getTipoRevisiones(),
      this.getCatalogoEtapaRevisiones(),
      this.revisionServicio.getNegocio()
    )
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getCatalogoEtapaRevisiones() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetCatalogoEtapaRevisiones}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      );
  }

  getRevisionesFiltro(revisionfiltro: RevisionesFiltroDTO, IdEmpleado: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.GetRevisionesFiltro}`, { filtro: revisionfiltro, idEmpleado: IdEmpleado }, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getCatalogoEstatusRubros() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetCatalogoEstatusRubros}`, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getChecklistSeguimiento(idRevision: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.GetChecklistSeguimiento}`, { idRevision }, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getRevision(idRevision: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.GetRevision}`, { idRevision }, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  getRangoCalificacionChecklists() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetRangoCalificacionChecklists}`, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  loadInitChecklistValidacion(idRevision: number) {
    return zip(
      this.getCatalogoEstatusRubros(),
      this.getChecklistSeguimiento(idRevision),
      this.getRevision(idRevision),
      this.getRangoCalificacionChecklists()
    )
    .pipe(
      catchError(this.handleError)
    );
  }

  postRubroMotivoRechazo(rubroMotivoRechazo: RubroMotivoRechazo) {
    return this.http.post<ResponseService>(`${this.URL}${methods.SetTranRubroMotivoRechazo}`, rubroMotivoRechazo, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
